import React, { Fragment, ReactNode, useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';

import '../styles/index.scss';

import Toasts from './reusables/Toast';
import MessageModal from './modals/Message';

import { closeAllModals } from '../store/slices/modal';

const App = ({ children }: { children: ReactNode }) => {

  const location = useLocation();
  const dispatch = useDispatch();

  useLayoutEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    dispatch(closeAllModals());

    // eslint-disable-next-line
  }, [location]);

  return (
    <Fragment>

      <Toasts />
      <MessageModal />

      <div className="immployer_admin__app">
        {children}
      </div>

    </Fragment>
  );
};

export default App;